import React from 'react'
import { Tooltip } from 'antd'
import AlertIcon from '../../assets/images/alert-circle.png'
import { ReactComponent as CompanyLogo } from '../../assets/images/company-images/company-circle.svg'
import { companyNameFull } from '../../constants'

const ImageContent = ({ imgSrc }) => {
  return (
    <div className='p-2'>
      <p className="text-black font-semibold text-2xl">
        Language Level System
      </p>
      <div className="flex-row gap-1 flex pb-8">
        <p className="text-black">
          International standard /
        </p>
        <a className="font-semibold" target='_blank' rel="noopener noreferrer" href={process.env.REACT_APP_CERF_LANGUAGE}>
          <div className="flex flex-row gap-1 items-center">
            <CompanyLogo />
            <p className='text-blue-900 font-semibold'>{companyNameFull} Internal Scale</p>
          </div>
        </a>
      </div>
      <img src={imgSrc} alt='help' />
    </div>
  )
}

export const ImageTooltip = ({ placement, imgSrc }) => {
  return (
    <div>
      <Tooltip placement={placement || 'bottom'} title={<ImageContent imgSrc={imgSrc} />} color='#FFF' overlayStyle={{ maxWidth: '520px' }}>
        <div className='w-5 h-5'>
          <img src={AlertIcon} alt='i' />
        </div>
      </Tooltip>
    </div>
  )
}
